<template>
  <p></p>
</template>
<script>
export default {}
</script>
<style scoped>
p {
  margin: 0;
  font-weight: bold;
  padding: 1em;
}
</style>
